// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .special-hours-wrapper {
    background-color: ${(props) => props.theme.colors.HP_BG_COLOR};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED}
      ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .heading-text {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: 800;
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .special-holiday-line2-wrapper,
  .special-hours-msg {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
  }
  .special-holiday-line2-wrapper {
    display: flex;
  }
  .line2-time,
  .line2-date {
    font-weight: bold;
  }
  .line2-date,
  .line2-on {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  }
`;
